import { Big } from 'big.js';
import { TenantJobLine } from '~/lib/model';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import BreJob from '~/tenants/bre/model/BreJob';
import { BreOrderType } from '~/tenants/bre/model/enums';
import BreDuskConfig from '~/tenants/bre/performable/dusk/BreDuskConfig';

export default class BreDuskJob extends BreJob<typeof BreDuskConfig> {
  get performable(): typeof BreDuskConfig {
    return BreDuskConfig;
  }

  get configurable(): boolean {
    return true;
  }

  get assignable() {
    return true;
  }

  // get input(): TenantJobInput | null {
  //   return {
  //     performables: [BrePhotosConfig.id],
  //     required: this.metadata.quantity,
  //     title: 'Select Photos',
  //     description: 'Select the photos you want to digitally convert from day to dusk.',
  //   };
  // }

  get eligible(): boolean {
    return this.isOneOf(BreOrderType.RESIDENTIAL, BreOrderType.COMMERCIAL, BreOrderType.RENTAL);
  }

  defaultValue(): ZodVersionedMetadata<(typeof BreDuskConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      quantity: 1,
    };
  }

  revenueLines(): TenantJobLine[] {
    const lines: TenantJobLine[] = super.revenueLines();

    if (this.metadata.quantity > 0) {
      lines.push({
        id: 'photos',
        description: `${this.metadata.quantity} Day to Dusk Photos`,
        amount: new Big(BreDuskJob.rate()).times(this.metadata.quantity),
      });

      if (this.orderContainsSocialPackage) {
        lines.push({
          id: 'free_dusk_edit',
          description: 'Complementary Day-to-Dusk',
          amount: new Big(BreDuskJob.rate()).neg(),
          discount: true,
        });
      }
    }

    return lines;
  }

  static rate(): TMoney {
    return '30.00';
  }
}
